import { render, staticRenderFns } from "./OpenSettingIndex.vue?vue&type=template&id=70e90dc7&scoped=true"
import script from "./OpenSettingIndex.vue?vue&type=script&lang=js"
export * from "./OpenSettingIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e90dc7",
  null
  
)

export default component.exports